<template>
  <v-dialog v-model="newUserDialog" max-width="1200px" persistent scrollable>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title><h4>Set Commission Area</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon
          @click="$emit('setDialog', false), (districtCheck = false)"
          color="black"
          size="30"
          >close</v-icon
        >
      </v-toolbar>

      <v-card-text style="height: auto;" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-toolbar-title><h4>Manager Commission</h4> </v-toolbar-title>
          <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
              <v-flex xs12 sm6>
                <v-autocomplete
                  :rules="[(v) => !!v || 'Required']"
                  outline
                  v-model="form.province"
                  :items="province_list"
                  outlined
                  :loading="loadingProvince"
                  item-text="province_name_th"
                  item-value="province_id"
                  dense
                  label="Province"
                  class="mr-2"
                  @change="
                    (districtCheck = true), (districtList = []);
                    getDistrictList();
                  "
                >
                  ></v-autocomplete
                >
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete
                  v-if="districtCheck"
                  :rules="[(v) => !!v || 'Required']"
                  outline
                  v-model="form.district"
                  :items="DistrcitCommissionByid"
                  outlined
                  :loading="loadingProvince"
                  item-text="district_name_th"
                  item-value="district_id"
                  dense
                  label="District"
                ></v-autocomplete>
                <v-autocomplete
                  v-else
                  disabled
                  :rules="[(v) => !!v || 'Required']"
                  outline
                  v-model="form.district"
                  :items="DistrcitCommissionByid"
                  outlined
                  :loading="loadingProvince"
                  item-text="district_name_th"
                  item-value="district_id"
                  dense
                  label="District"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  :rules="[rules.required, rules.counter, rules.email]"
                  v-model="form.extra"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Extra Transport Price(%)"
                  outline
                  @input="check()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  :rules="[rules.required, rules.counter, rules.email]"
                  v-model="form.gp"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="GP(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  :rules="[rules.required, rules.counter, rules.email]"
                  v-model="form.fee"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Fee Delivery(%)"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  :rules="[rules.required, rules.counter, rules.email]"
                  v-model="form.promotion"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Promotion(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  :rules="[rules.required, rules.counter, rules.email]"
                  v-model="form.differentail"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Additional Fee(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  :rules="[rules.required, rules.counter, rules.email]"
                  v-model="form.guarantee"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Guarantee Fee(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  :rules="[rules.required, rules.counter, rules.email]"
                  v-model="form.smallorder"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Small Order Price(%)"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div style="border-bottom: 1.5px dotted #9E9E9E;"></div>
          </v-container>
          <v-toolbar-title><h4>Weserve Commission</h4> </v-toolbar-title>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <v-text-field
                  v-if="form.extra != null"
                  disabled
                  v-model="100 - form.extra"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Extra Transport Price(%)"
                  outline
                ></v-text-field>
                <v-text-field
                  v-else
                  disabled
                  v-model="form.extra"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Extra Transport Price(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  v-if="form.gp != null"
                  disabled
                  v-model="100 - form.gp"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="GP(%)"
                  outline
                ></v-text-field>
                <v-text-field
                  v-else
                  disabled
                  v-model="form.gp"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="GP(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  v-if="form.fee != null"
                  disabled
                  v-model="100 - form.fee"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Fee Delivery(%)"
                  outline
                ></v-text-field>
                <v-text-field
                  v-else
                  disabled
                  v-model="form.fee"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Fee Delivery(%)"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <v-text-field
                  v-if="form.promotion != null"
                  disabled
                  v-model="100 - form.promotion"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Promotion(%)"
                  outline
                ></v-text-field>
                <v-text-field
                  v-else
                  disabled
                  v-model="form.promotion"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Promotion(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  v-if="form.promotion != null"
                  disabled
                  v-model="100 - form.differentail"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Additional Fee(%)"
                  outline
                ></v-text-field>
                <v-text-field
                  v-else
                  disabled
                  v-model="form.differentail"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Additional Fee(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  v-if="form.promotion != null"
                  disabled
                  v-model="100 - form.guarantee"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Guarantee Fee(%)"
                  outline
                ></v-text-field>
                <v-text-field
                  v-else
                  disabled
                  v-model="form.guarantee"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Guarantee Fee(%)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  v-if="form.smallorder != null"
                  disabled
                  v-model="100 - form.smallorder"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Small Order Price(%)"
                  outline
                ></v-text-field>
                <v-text-field
                  v-else
                  disabled
                  v-model="form.smallorder"
                  placeholder="ระบุจำนวนที่ต้องการ"
                  label="Small Order Price(%)"
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions style="padding-bottom: 30px" class="pr-4">
            <v-spacer></v-spacer>
            <v-btn
              @click="addCommission()"
              :loading="isAdding"
              dark
              color="black"
              style="
            width: 120px;
            background: #000000 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 7px;
            font-weight: bold;
            letter-spacing: 0.1rem;
          "
              >CONFIRM</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import _ from "lodash";

let _this = this;
export default {
  props: ["newUserDialog"],
  data() {
    return {
      districtCheck: false,
      decimal: ".",
      rules: {
        counter: (value) => (value >= 0 && value <= 100) || "Min 0 or Max100",
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^[-+]?[0-9]+\.[0-9]+$/;
          return !pattern.test(value) || "Not Decimal";
        },
      },
      valid: true,
      loadingProvince: false,
      districtList: [],
      isLoadingDistrict: false,
      validTel: false,
      isAdding: false,
      form: {
        extra: "",
        gp: "",
        fee: "",
        promotion: "",
        differentail: "",
        guarantee: "",
        province: "",
        district: "",
        smallorder: "",
      },
    };
  },
  watch: {
    async newUserDialog() {
      if (this.newUserDialog == true) {
        this.clear();
        this.loadingProvince = true;
        await this.$store.dispatch("fetchCommission/fetchManagerCommission");
        this.loadingProvince = false;
      }
    },
  },
  computed: {
    ...mapMutations({
      getDataCommission: "fetchCommission/setDistrcitCommissionById",
    }),
    ...mapState({
      district_list: (state) => state.fetchProvinceBack.district_list,
      DistrcitCommissionByid: (state) =>
        state.fetchCommission.DistrcitCommissionByid,
    }),
    ...mapGetters({
      province_list: "fetchProvinceBack/provinceSplited",
    }),
  },
  methods: {
    ...mapActions({
      fetchDistrcitCommissionByid:
        "fetchCommission/fetchDistrcitCommissionByid",
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async addCommission() {
      if (this.$refs.form.validate()) {
        let commissionlist = {
          commission_area_province_id: this.form.province,
          commission_area_district_id: this.form.district,
          commission_area_extra_transport_price: this.form.extra,
          commission_area_gp: this.form.gp,
          commission_area_fee_delivery: this.form.fee,
          commission_area_promotion: this.form.promotion,
          commission_area_fee_delivery_differentail: this.form.differentail,
          commission_area_guarantee_fee: this.form.guarantee,
          commission_area_small_order_price: this.form.smallorder
        };
        this.isAdding = true;
        let _this = this;
        this.$emit("onSaved", {
          form: commissionlist,
          done() {
            _this.isAdding = false;
          },
        });
      }
    },
    async getDistrictList() {
      this.DistrcitCommissionByid = [];
      this.loadingDistrict = true;
      await this.fetchDistrcitCommissionByid({
        manager_id: this.form.province,
      });
      this.loadingDistrict = false;
      this.isLoadingDistrict = false;
    },
    clear() {
      (this.form = {
        extra: "",
        gp: "",
        fee: "",
        promotion: "",
        province: "",
        district: "",
        smallorder: "",
      }),
        (this.validTel = false);
      this.$refs.form.resetValidation();
      this.imageSrc = null;
    },
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
